import _ from 'underscore';

import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatMatchType, MATCH_TYPE_IDS } from '@bingads-webui-campaign/recommendation-core';
import template from './match-type-selector-column.pug';

export class MatchTypeSelectorColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, recommendationType, view }) {
    const title = i18n.getString('Details_View_Match_Type') || '__Match type__';
    super({
      name: 'matchType',
      property: 'Opportunities/MatchType',
      title,
      bodyClasses: ['grid-column-matchType'],
      colClasses: ['col-matchType'],
      sortable: 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.KeywordOpportunitySummary/MatchTypeStr',
      helpId: 'Pop_BA_Recommendations_MatchType',
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.recommendationType = recommendationType;
    this.view = view;
  }

  template({
    value: {
      Opportunities,
    },
  }) {
    const { i18n } = this;
    const defaultMatchType = Opportunities[0].NewMatchType || Opportunities[0].MatchType;
    // Get all match types
    const matchTypes = [];
    _.each(MATCH_TYPE_IDS, (matchTypeId) => {
      matchTypes.push({
        id: matchTypeId,
        name: formatMatchType(matchTypeId, i18n),
      });
    });
    return template({
      i18n,
      defaultMatchType,
      matchTypes,
    });
  }

  get property() {
    return {
      get: _.identity,
      property: 'Opportunities/MatchType',
    };
  }
}
